import { Injectable } from '@angular/core';
import { AbstractDataServiceDtoSummaryAdapter } from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {SaleRetrocessionSummaryModel} from "../../../api/entity/saleRetrocessionSummary.model";
import {SaleRetrocessionSummaryConverter} from "../../../api/entity/converter/saleRetrocessionSummary.converter";
import {SaleRetrocessionModel} from "../../../api/entity/saleRetrocession.model";
import {SaleRetrocessionDataService} from "./sale-retrocession-data.service";


@Injectable()
export class SaleRetrocessionSummaryDataServiceAdapter
    extends AbstractDataServiceDtoSummaryAdapter<SaleRetrocessionSummaryModel,
        SaleRetrocessionSummaryConverter,
        SaleRetrocessionModel> {
    constructor(dataService: SaleRetrocessionDataService, converter: SaleRetrocessionSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): SaleRetrocessionModel {
        return new SaleRetrocessionModel();
    }
}
